(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abyssgate-skull-vortex-rug"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ag').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const picker=root.querySelector('[data-ag-variant]'),main=root.querySelector('.ag__main'),thumbs=[...root.querySelectorAll('.ag__thumb')],price=root.querySelector('[data-ag-price]'),add=root.querySelector('[data-ag-add]'),label=root.querySelector('[data-ag-label]');if(!picker)return;const show=(u,a,t)=>{if(main&&u){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=u;if(a)main.alt=a}thumbs.forEach(x=>x.classList.toggle('is-active',x===t))};const update=()=>{const o=picker.options[picker.selectedIndex];if(!o)return;if(price)price.textContent=o.dataset.price||'';const ok=o.dataset.available==='true';if(add)add.disabled=!ok;if(label)label.textContent=ok?'Open the gate':'Sold out';const t=thumbs.find(x=>x.dataset.mediaId===o.dataset.mediaId);if(t)show(t.dataset.imageUrl,t.dataset.imageAlt,t);else if(o.dataset.imageUrl)show(o.dataset.imageUrl,o.dataset.imageAlt,null);const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u)};picker.addEventListener('change',update);thumbs.forEach(t=>t.addEventListener('click',()=>{const id=t.dataset.variantId,o=id?[...picker.options].find(x=>x.value===id):null;if(o){picker.value=id;picker.dispatchEvent(new Event('change',{bubbles:true}))}else show(t.dataset.imageUrl,t.dataset.imageAlt,t)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurelia-date-watch"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.au').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const picker=root.querySelector('[data-au-variant]'),main=root.querySelector('.au__main'),thumbs=[...root.querySelectorAll('.au__thumb')],price=root.querySelector('[data-au-price]'),compare=root.querySelector('[data-au-compare]'),add=root.querySelector('[data-au-add]'),label=root.querySelector('[data-au-label]');if(!picker)return;const show=(url,alt,thumb)=>{if(main&&url){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;if(alt)main.alt=alt}thumbs.forEach(t=>t.classList.remove('is-active'));if(thumb)thumb.classList.add('is-active')};picker.addEventListener('change',()=>{const o=picker.options[picker.selectedIndex];if(price)price.textContent=o.dataset.price||'';if(compare){compare.textContent=o.dataset.compare||'';compare.style.display=o.dataset.hasCompare==='true'?'':'none'}const ok=o.dataset.available==='true';if(add)add.disabled=!ok;if(label)label.textContent=ok?'Add Aurelia':'Sold out';const t=thumbs.find(x=>x.dataset.media===o.dataset.media);if(t)show(t.dataset.url,t.dataset.alt,t);else if(o.dataset.url)show(o.dataset.url,o.dataset.alt,null)});thumbs.forEach(t=>t.addEventListener('click',()=>{if(t.dataset.variant&&[...picker.options].some(o=>o.value===t.dataset.variant)){picker.value=t.dataset.variant;picker.dispatchEvent(new Event('change',{bubbles:true}))}else show(t.dataset.url,t.dataset.alt,t)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["candyclear-watch-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ccw').forEach((root)=>{
  if(root.dataset.ccwReady)return;
  root.dataset.ccwReady='true';
  const picker=root.querySelector('[data-ccw-variant]');
  const main=root.querySelector('.ccw__main-image');
  const thumbs=Array.from(root.querySelectorAll('.ccw__thumb'));
  const price=root.querySelector('[data-ccw-price]');
  const mobilePrice=root.querySelector('[data-ccw-mobile-price]');
  const add=root.querySelector('[data-ccw-add]');
  const addLabel=root.querySelector('[data-ccw-add-label]');
  if(!picker)return;
  const activate=(thumb)=>{
    thumbs.forEach(t=>{t.classList.remove('is-active');t.setAttribute('aria-pressed','false')});
    if(thumb){thumb.classList.add('is-active');thumb.setAttribute('aria-pressed','true')}
  };
  const show=(url,alt,thumb)=>{
    if(main&&url){
      main.classList.add('is-changing');
      main.onload=()=>main.classList.remove('is-changing');
      main.onerror=()=>main.classList.remove('is-changing');
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src=url;
      if(alt)main.alt=alt;
    }
    activate(thumb);
  };
  const update=()=>{
    const option=picker.options[picker.selectedIndex];
    if(!option)return;
    if(price)price.textContent=option.dataset.price||'';
    if(mobilePrice)mobilePrice.textContent=option.dataset.price||'';
    const available=option.dataset.available==='true';
    if(add)add.disabled=!available;
    if(addLabel)addLabel.textContent=available?'Add some color':'Sold out';
    const mediaId=option.dataset.mediaId;
    const thumb=thumbs.find(t=>t.dataset.mediaId===mediaId);
    if(thumb)show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb);
    else if(option.dataset.imageUrl)show(option.dataset.imageUrl,option.dataset.imageAlt,null);
    const url=new URL(window.location.href);
    url.searchParams.set('variant',option.value);
    window.history.replaceState({},'',url);
  };
  picker.addEventListener('change',update);
  thumbs.forEach((thumb)=>thumb.addEventListener('click',()=>{
    const linked=thumb.dataset.variantId;
    const option=linked?Array.from(picker.options).find(o=>o.value===linked):null;
    if(option){
      picker.value=linked;
      picker.dispatchEvent(new Event('change',{bubbles:true}));
    }else{
      show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb);
    }
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cat-hammock-scratcher"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-chm-section]').forEach((root) => {
    const mainImage = root.querySelector('.chm__hero-image');
    const form = root.querySelector('[data-buy-form]');
    const mobileAdd = root.querySelector('[data-chm-mobile-add]');

    root.querySelectorAll('[data-chm-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.chmImg;
        mainImage.alt = btn.dataset.chmAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-chm-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));

    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cat-scratcher-arch"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-csa-section]').forEach((root) => {
    const mainImage = root.querySelector('.csa__hero-image');
    const form = root.querySelector('[data-buy-form]');
    const mobileAdd = root.querySelector('[data-csa-mobile-add]');

    root.querySelectorAll('[data-csa-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.csaImg;
        mainImage.alt = btn.dataset.csaAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-csa-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));

    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chicken-hat-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-id]').forEach((section) => {
    if (section.dataset.rwReady) return;
    section.dataset.rwReady = 'true';
    const variantsNode = section.querySelector('[data-rw-variants]');
    const picker = section.querySelector('[data-rw-variant]');
    if (!variantsNode || !picker) return;
    const variants = JSON.parse(variantsNode.textContent);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    const mainImage = section.querySelector('.rw__main-image');
    const thumbnails = Array.from(section.querySelectorAll('[data-rw-image]'));
    const showImage = (url, alt) => {
      if (!mainImage || !url) return;
      mainImage.style.opacity = '0';
      mainImage.onload = () => { mainImage.style.opacity = '1'; };
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = url;
      if (alt) mainImage.alt = alt;
    };
    const activateThumbnail = (thumbnail) => {
      thumbnails.forEach((item) => item.classList.remove('is-active'));
      if (thumbnail) thumbnail.classList.add('is-active');
    };
    const update = () => {
      const variant = variants.find((item) => String(item.id) === picker.value);
      if (!variant) return;
      section.querySelector('[data-rw-price]').textContent = money.format(variant.price / 100);
      const mobilePrice = section.querySelector('[data-rw-mobile-price]');
      if (mobilePrice) mobilePrice.textContent = money.format(variant.price / 100);
      section.querySelectorAll('[data-rw-add], [data-rw-mobile-add]').forEach((button) => { button.disabled = !variant.available; });
      const label = section.querySelector('[data-rw-add-label]');
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const selectedOption = picker.options[picker.selectedIndex];
      const mediaId = selectedOption?.dataset.mediaId;
      const matchingThumbnail = thumbnails.find((item) => item.dataset.mediaId === mediaId);
      if (matchingThumbnail) {
        showImage(matchingThumbnail.dataset.rwImage, matchingThumbnail.dataset.rwAlt);
        activateThumbnail(matchingThumbnail);
      } else if (variant.featured_image) {
        showImage(variant.featured_image.src, variant.featured_image.alt || mainImage?.alt);
        activateThumbnail(null);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    picker.addEventListener('change', update);
    thumbnails.forEach((button) => button.addEventListener('click', () => {
      const linkedVariantId = button.dataset.rwVariantId;
      const linkedOption = linkedVariantId ? Array.from(picker.options).find((option) => option.value === linkedVariantId && !option.disabled) : null;
      if (linkedOption) {
        picker.value = linkedVariantId;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        showImage(button.dataset.rwImage, button.dataset.rwAlt);
        activateThumbnail(button);
      }
    }));
    const mobileAdd = section.querySelector('[data-rw-mobile-add]');
    if (mobileAdd) mobileAdd.addEventListener('click', () => section.querySelector('[data-rw-add]').click());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-product-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-xmas-section]').forEach(root=>{const img=root.querySelector('.xmas__hero-image');const picker=root.querySelector('[data-buy-variant]');const form=root.querySelector('[data-buy-form]');const price=root.querySelector('[data-buy-price]');const mobilePrice=root.querySelector('[data-xmas-mobile-price]');const atc=root.querySelector('[data-buy-atc]');const label=root.querySelector('[data-buy-atc-label]');const mobileAdd=root.querySelector('[data-xmas-mobile-add]');let variants=[];try{variants=JSON.parse(root.querySelector('[data-xmas-variants]')?.textContent||'[]')}catch(e){}const money=c=>{try{return new Intl.NumberFormat(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}};const update=id=>{const v=variants.find(x=>String(x.id)===String(id));if(!v)return;if(picker)picker.value=String(v.id);const p=money(v.price);if(price)price.textContent=p;if(mobilePrice)mobilePrice.textContent=p;if(atc)atc.disabled=!v.available;if(mobileAdd)mobileAdd.disabled=!v.available;if(label)label.textContent=v.available?'Add to cart':'Sold out';if(v.featured_image&&img){img.src=v.featured_image.src;img.removeAttribute('srcset');root.querySelectorAll('[data-xmas-img]').forEach(b=>{const same=v.featured_media&&String(b.dataset.mediaId)===String(v.featured_media.id);b.classList.toggle('is-active',!!same)})}try{const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}catch(e){}};root.querySelectorAll('[data-xmas-img]').forEach(btn=>btn.addEventListener('click',()=>{if(img){img.src=btn.dataset.xmasImg;img.alt=btn.dataset.xmasAlt||'';img.removeAttribute('srcset')}root.querySelectorAll('[data-xmas-img]').forEach(x=>x.classList.remove('is-active'));btn.classList.add('is-active');const linked=variants.find(v=>v.featured_media&&String(v.featured_media.id)===String(btn.dataset.mediaId));if(linked)update(linked.id)}));if(picker&&picker.tagName==='SELECT')picker.addEventListener('change',()=>update(picker.value));mobileAdd?.addEventListener('click',()=>form?.requestSubmit())})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["classic-watch-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cw-section]').forEach((section)=>{
  if(section.dataset.ready)return;section.dataset.ready='1';
  const variantData=section.querySelector('[data-cw-variants]');
  const picker=section.querySelector('[data-cw-variant]');
  if(!variantData||!picker)return;
  const variants=JSON.parse(variantData.textContent);
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
  const sync=()=>{
    const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;
    section.querySelector('[data-cw-price]').textContent=formatter.format(v.price/100);
    const mp=section.querySelector('[data-cw-mobile-price]');if(mp)mp.textContent=formatter.format(v.price/100);
    section.querySelectorAll('[data-cw-atc],[data-cw-mobile-add]').forEach(b=>b.disabled=!v.available);
    const lab=section.querySelector('[data-cw-atc-label]');if(lab)lab.textContent=v.available?'Add to cart':'Sold out';
    const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
  };
  picker.addEventListener('change',sync);
  section.querySelectorAll('[data-cw-pick]').forEach(b=>b.addEventListener('click',()=>{picker.value=b.dataset.cwPick;picker.dispatchEvent(new Event('change',{bubbles:true}));picker.scrollIntoView({behavior:'smooth',block:'center'});}));
  section.querySelectorAll('[data-cw-img]').forEach(b=>b.addEventListener('click',()=>{const img=section.querySelector('.cw__hero-image');img.src=b.dataset.cwImg;img.alt=b.dataset.cwAlt;section.querySelectorAll('.cw__thumb').forEach(t=>t.classList.remove('is-active'));b.classList.add('is-active');}));
  const mob=section.querySelector('[data-cw-mobile-add]');if(mob)mob.addEventListener('click',()=>section.querySelector('[data-cw-atc]').click());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clear-event-bag-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cb-section]').forEach((section)=>{
  if(section.dataset.ready)return;
  section.dataset.ready='1';
  const variantData=section.querySelector('[data-cb-variants]');
  const picker=section.querySelector('[data-cb-variant]');
  const variants=variantData?JSON.parse(variantData.textContent):[];
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
  const sync=()=>{
    if(!picker||!variants.length)return;
    const selectedId=picker.value;
    const variant=variants.find((item)=>String(item.id)===String(selectedId));
    if(!variant)return;
    const price=formatter.format(variant.price/100);
    const priceNode=section.querySelector('[data-cb-price]');
    const mobilePrice=section.querySelector('[data-cb-mobile-price]');
    if(priceNode)priceNode.textContent=price;
    if(mobilePrice)mobilePrice.textContent=price;
    section.querySelectorAll('[data-cb-atc],[data-cb-mobile-add]').forEach((button)=>button.disabled=!variant.available);
    const label=section.querySelector('[data-cb-atc-label]');
    if(label)label.textContent=variant.available?'Add to cart':'Sold out';
    const url=new URL(location.href);
    url.searchParams.set('variant',variant.id);
    history.replaceState({},'',url);
  };
  if(picker&&picker.tagName==='SELECT')picker.addEventListener('change',sync);
  section.querySelectorAll('[data-cb-img]').forEach((button)=>button.addEventListener('click',()=>{
    const updateImage=()=>{
      const image=section.querySelector('.cb__hero-image');
      if(!image)return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src=button.dataset.cbImg;
      image.alt=button.dataset.cbAlt||'';
      section.querySelectorAll('.cb__thumb').forEach((thumb)=>{thumb.classList.remove('is-active');thumb.setAttribute('aria-pressed','false');});
      button.classList.add('is-active');
      button.setAttribute('aria-pressed','true');
    };
    if(document.startViewTransition)document.startViewTransition(updateImage);else updateImage();
  }));
  const mobileButton=section.querySelector('[data-cb-mobile-add]');
  const addButton=section.querySelector('[data-cb-atc]');
  if(mobileButton&&addButton)mobileButton.addEventListener('click',()=>addButton.click());
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clearline-duo-tote-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cld').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const main=root.querySelector('.cld__main');
  const thumbs=Array.from(root.querySelectorAll('.cld__thumb'));
  thumbs.forEach((thumb)=>{
    thumb.addEventListener('click',()=>{
      if(main){
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src=thumb.dataset.imageUrl;
        main.alt=thumb.dataset.imageAlt||main.alt;
      }
      thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-pop-watch"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-id]').forEach((section) => {
    if (section.dataset.rwReady) return;
    section.dataset.rwReady = 'true';
    const variantsNode = section.querySelector('[data-rw-variants]');
    const picker = section.querySelector('[data-rw-variant]');
    if (!variantsNode || !picker) return;
    const variants = JSON.parse(variantsNode.textContent);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    const mainImage = section.querySelector('.rw__main-image');
    const thumbnails = Array.from(section.querySelectorAll('[data-rw-image]'));
    const showImage = (url, alt) => {
      if (!mainImage || !url) return;
      mainImage.style.opacity = '0';
      mainImage.onload = () => { mainImage.style.opacity = '1'; };
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = url;
      if (alt) mainImage.alt = alt;
    };
    const activateThumbnail = (thumbnail) => {
      thumbnails.forEach((item) => item.classList.remove('is-active'));
      if (thumbnail) thumbnail.classList.add('is-active');
    };
    const update = () => {
      const variant = variants.find((item) => String(item.id) === picker.value);
      if (!variant) return;
      section.querySelector('[data-rw-price]').textContent = money.format(variant.price / 100);
      const mobilePrice = section.querySelector('[data-rw-mobile-price]');
      if (mobilePrice) mobilePrice.textContent = money.format(variant.price / 100);
      section.querySelectorAll('[data-rw-add], [data-rw-mobile-add]').forEach((button) => { button.disabled = !variant.available; });
      const label = section.querySelector('[data-rw-add-label]');
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const selectedOption = picker.options[picker.selectedIndex];
      const mediaId = selectedOption?.dataset.mediaId;
      const matchingThumbnail = thumbnails.find((item) => item.dataset.mediaId === mediaId);
      if (matchingThumbnail) {
        showImage(matchingThumbnail.dataset.rwImage, matchingThumbnail.dataset.rwAlt);
        activateThumbnail(matchingThumbnail);
      } else if (variant.featured_image) {
        showImage(variant.featured_image.src, variant.featured_image.alt || mainImage?.alt);
        activateThumbnail(null);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    picker.addEventListener('change', update);
    thumbnails.forEach((button) => button.addEventListener('click', () => {
      const linkedVariantId = button.dataset.rwVariantId;
      const linkedOption = linkedVariantId ? Array.from(picker.options).find((option) => option.value === linkedVariantId && !option.disabled) : null;
      if (linkedOption) {
        picker.value = linkedVariantId;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        showImage(button.dataset.rwImage, button.dataset.rwAlt);
        activateThumbnail(button);
      }
    }));
    const mobileAdd = section.querySelector('[data-rw-mobile-add]');
    if (mobileAdd) mobileAdd.addEventListener('click', () => section.querySelector('[data-rw-add]').click());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorpop-kids-watch"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cpk').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const picker=root.querySelector('[data-cpk-variant]'),main=root.querySelector('.cpk__main'),thumbs=[...root.querySelectorAll('.cpk__thumb')],price=root.querySelector('[data-cpk-price]'),add=root.querySelector('[data-cpk-add]'),label=root.querySelector('[data-cpk-label]');if(!picker)return;const show=(url,alt,thumb)=>{if(main&&url){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;if(alt)main.alt=alt}thumbs.forEach(t=>t.classList.remove('is-active'));if(thumb)thumb.classList.add('is-active')};const update=()=>{const o=picker.options[picker.selectedIndex];if(price)price.textContent=o.dataset.price||'';const ok=o.dataset.available==='true';if(add)add.disabled=!ok;if(label)label.textContent=ok?'Add to cart':'Sold out';const th=thumbs.find(t=>t.dataset.mediaId===o.dataset.mediaId);if(th)show(th.dataset.imageUrl,th.dataset.imageAlt,th);else if(o.dataset.imageUrl)show(o.dataset.imageUrl,o.dataset.imageAlt,null)};picker.addEventListener('change',update);thumbs.forEach(t=>t.addEventListener('click',()=>{if(t.dataset.variantId&&[...picker.options].some(o=>o.value===t.dataset.variantId)){picker.value=t.dataset.variantId;picker.dispatchEvent(new Event('change',{bubbles:true}))}else show(t.dataset.imageUrl,t.dataset.imageAlt,t)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozy-cat-scratch-nest"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ccn-section]').forEach((root) => {
    const mainImage = root.querySelector('.ccn__hero-image');
    const form = root.querySelector('[data-buy-form]');
    const mobileAdd = root.querySelector('[data-ccn-mobile-add]');

    root.querySelectorAll('[data-ccn-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.ccnImg;
        mainImage.alt = btn.dataset.ccnAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-ccn-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));

    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crescent-hollow-out-bag-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-jhb-section]').forEach(root=>{const img=root.querySelector('.jhb__hero-image'),sel=root.querySelector('[data-buy-variant]'),form=root.querySelector('[data-buy-form]'),price=root.querySelector('[data-buy-price]'),mprice=root.querySelector('[data-jhb-mobile-price]'),atc=root.querySelector('[data-buy-atc]'),label=root.querySelector('[data-buy-atc-label]'),madd=root.querySelector('[data-jhb-mobile-add]');let variants=[];try{variants=JSON.parse(root.querySelector('[data-jhb-variants]')?.textContent||'[]')}catch(e){}const money=c=>{try{return new Intl.NumberFormat(undefined,{style:'currency',currency:'{{ cart.currency.iso_code }}'}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}};const update=id=>{const v=variants.find(x=>String(x.id)===String(id));if(!v)return;if(sel)sel.value=String(v.id);const p=money(v.price);if(price)price.textContent=p;if(mprice)mprice.textContent=p;if(atc)atc.disabled=!v.available;if(madd)madd.disabled=!v.available;if(label)label.textContent=v.available?'Add to cart':'Sold out';if(v.featured_image&&img){img.src=v.featured_image.src;img.removeAttribute('srcset');root.querySelectorAll('[data-jhb-img]').forEach(b=>b.classList.toggle('is-active',!!(v.featured_media&&String(b.dataset.mediaId)===String(v.featured_media.id))))}try{const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}catch(e){}};root.querySelectorAll('[data-jhb-img]').forEach(btn=>btn.addEventListener('click',()=>{if(img){img.src=btn.dataset.jhbImg;img.alt=btn.dataset.jhbAlt||'';img.removeAttribute('srcset')}root.querySelectorAll('[data-jhb-img]').forEach(x=>x.classList.remove('is-active'));btn.classList.add('is-active');const linked=variants.find(v=>v.featured_media&&String(v.featured_media.id)===String(btn.dataset.mediaId));if(linked)update(linked.id)}));sel?.addEventListener('change',()=>update(sel.value));madd?.addEventListener('click',()=>form?.requestSubmit())})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["croc-embossed-satchel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-csh-section]').forEach((root) => {
    const mainImage = root.querySelector('.csh__hero-image');
    const select = root.querySelector('[data-buy-variant]');
    const form = root.querySelector('[data-buy-form]');
    const price = root.querySelector('[data-buy-price]');
    const mobilePrice = root.querySelector('[data-csh-mobile-price]');
    const atc = root.querySelector('[data-buy-atc]');
    const atcLabel = root.querySelector('[data-buy-atc-label]');
    const mobileAdd = root.querySelector('[data-csh-mobile-add]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-csh-variants]')?.textContent || '[]'); } catch(e) {}

    const money = (cents) => {
      const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(cents/100); }
      catch(e){ return '$' + (cents/100).toFixed(2); }
    };

    const updateVariant = (id) => {
      const variant = variants.find((v) => String(v.id) === String(id));
      if (!variant) return;
      if (select) select.value = String(variant.id);
      const formatted = money(variant.price);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      if (atc) atc.disabled = !variant.available;
      if (mobileAdd) mobileAdd.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      const mediaId = variant.featured_media ? String(variant.featured_media.id) : '';
      const matchingThumb = mediaId ? Array.from(root.querySelectorAll('[data-csh-img]')).find((btn) => String(btn.dataset.mediaId) === mediaId) : null;
      if (matchingThumb && mainImage) {
        mainImage.src = matchingThumb.dataset.cshImg;
        mainImage.alt = matchingThumb.dataset.cshAlt || '';
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-csh-img]').forEach((btn) => btn.classList.toggle('is-active', btn === matchingThumb));
      } else if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch(e) {}
    };

    root.querySelectorAll('[data-csh-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.cshImg;
        mainImage.alt = btn.dataset.cshAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-csh-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
      const linked = variants.find((variant) => variant.featured_media && String(variant.featured_media.id) === String(btn.dataset.mediaId));
      if (linked) updateVariant(linked.id);
    }));

    select?.addEventListener('change', () => updateVariant(select.value));
    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["denim-patchwork-bag-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-dpb-section]').forEach((root) => {
    const mainImage = root.querySelector('.dpb__hero-image');
    const select = root.querySelector('[data-buy-variant]');
    const form = root.querySelector('[data-buy-form]');
    const price = root.querySelector('[data-buy-price]');
    const mobilePrice = root.querySelector('[data-dpb-mobile-price]');
    const atc = root.querySelector('[data-buy-atc]');
    const atcLabel = root.querySelector('[data-buy-atc-label]');
    const mobileAdd = root.querySelector('[data-dpb-mobile-add]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-dpb-variants]')?.textContent || '[]'); } catch(e) {}

    const money = (cents) => {
      try { return new Intl.NumberFormat(undefined,{style:'currency',currency:'{{ cart.currency.iso_code }}'}).format(cents/100); }
      catch(e){ return '$' + (cents/100).toFixed(2); }
    };

    const updateVariant = (id) => {
      const variant = variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      if (select) select.value = String(variant.id);
      const formatted = money(variant.price);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      if (atc) atc.disabled = !variant.available;
      if (mobileAdd) mobileAdd.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-dpb-img]').forEach(btn => {
          const same = variant.featured_media && String(btn.dataset.mediaId) === String(variant.featured_media.id);
          btn.classList.toggle('is-active', !!same);
        });
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch(e) {}
    };

    root.querySelectorAll('[data-dpb-img]').forEach(btn => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.dpbImg;
        mainImage.alt = btn.dataset.dpbAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-dpb-img]').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');
      const linked = variants.find(v => v.featured_media && String(v.featured_media.id) === String(btn.dataset.mediaId));
      if (linked) updateVariant(linked.id);
    }));

    select?.addEventListener('change', () => updateVariant(select.value));
    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["five-product-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hp5-section]').forEach((section)=>{
  if(section.dataset.ready)return;
  section.dataset.ready='1';
  const dataNode=section.querySelector('[data-hp5-variants]');
  const picker=section.querySelector('[data-buy-variant]');
  const variants=dataNode?JSON.parse(dataNode.textContent):[];
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
  const sync=()=>{
    if(!picker||!variants.length)return;
    const variant=variants.find((item)=>String(item.id)===String(picker.value));
    if(!variant)return;
    const price=formatter.format(variant.price/100);
    const priceNode=section.querySelector('[data-buy-price]');
    const mobilePrice=section.querySelector('[data-hp5-mobile-price]');
    if(priceNode)priceNode.textContent=price;
    if(mobilePrice)mobilePrice.textContent=price;
    section.querySelectorAll('[data-buy-atc],[data-hp5-mobile-add]').forEach((button)=>button.disabled=!variant.available);
    const label=section.querySelector('[data-buy-atc-label]');
    if(label)label.textContent=variant.available?'Add to cart':'Sold out';

    // Keep the gallery in sync with the selected variant's assigned image.
    const variantImage=variant.featured_image;
    if(variantImage&&variantImage.src){
      const normalize=(value)=>String(value||'').split('?')[0].replace(/^https?:/,'');
      const image=section.querySelector('.hp5__hero-img');
      if(image){
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src=variantImage.src;
        image.alt=variantImage.alt||image.alt||'';
      }
      let matched=false;
      section.querySelectorAll('[data-hp5-img]').forEach((thumb)=>{
        const isMatch=normalize(thumb.dataset.hp5Img)===normalize(variantImage.src);
        thumb.classList.toggle('is-active',isMatch);
        thumb.setAttribute('aria-pressed',isMatch?'true':'false');
        if(isMatch)matched=true;
      });
      // A variant image can be assigned even if it is outside the visible thumbnail set.
      if(!matched)section.querySelectorAll('.hp5__thumb').forEach((thumb)=>{thumb.classList.remove('is-active');thumb.setAttribute('aria-pressed','false');});
    }

    const url=new URL(location.href);
    url.searchParams.set('variant',variant.id);
    history.replaceState({},'',url);
  };
  if(picker&&picker.tagName==='SELECT')picker.addEventListener('change',sync);
  section.querySelectorAll('[data-hp5-img]').forEach((button)=>button.addEventListener('click',()=>{
    const normalize=(value)=>String(value||'').split('?')[0].replace(/^https?:/,'');
    const clickedSrc=normalize(button.dataset.hp5Img);
    const linkedVariant=variants.find((item)=>item.featured_image&&normalize(item.featured_image.src)===clickedSrc);

    // If this thumbnail is assigned to a variant, make the product selection follow the image.
    if(linkedVariant&&picker){
      picker.value=String(linkedVariant.id);
      sync();
    }

    const changeImage=()=>{
      const image=section.querySelector('.hp5__hero-img');
      if(!image)return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src=button.dataset.hp5Img;
      image.alt=button.dataset.hp5Alt||'';
      section.querySelectorAll('.hp5__thumb').forEach((thumb)=>{thumb.classList.remove('is-active');thumb.setAttribute('aria-pressed','false');});
      button.classList.add('is-active');
      button.setAttribute('aria-pressed','true');
    };
    if(document.startViewTransition)document.startViewTransition(changeImage);else changeImage();
  }));
  const mobile=section.querySelector('[data-hp5-mobile-add]');
  const add=section.querySelector('[data-buy-atc]');
  if(mobile&&add)mobile.addEventListener('click',()=>add.click());
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giltedge-watch-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.glt').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const main=root.querySelector('.glt__main'),thumbs=[...root.querySelectorAll('.glt__thumb')];thumbs.forEach(t=>t.addEventListener('click',()=>{thumbs.forEach(x=>x.classList.remove('is-active'));t.classList.add('is-active');if(main){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=t.dataset.url;main.alt=t.dataset.alt||main.alt}}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gripforge-trainer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.gf').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const main=root.querySelector('.gf__main'),thumbs=[...root.querySelectorAll('.gf__thumb')];thumbs.forEach(t=>t.addEventListener('click',()=>{if(main){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=t.dataset.url;main.alt=t.dataset.alt||''}thumbs.forEach(x=>x.classList.remove('is-active'));t.classList.add('is-active')}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hootmotion-owl-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hm').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const main=root.querySelector('.hm__main');
  const thumbs=Array.from(root.querySelectorAll('.hm__thumb'));
  thumbs.forEach((thumb)=>{
    thumb.addEventListener('click',()=>{
      if(main){
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src=thumb.dataset.imageUrl;
        main.alt=thumb.dataset.imageAlt||main.alt;
      }
      thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-acrylic-markers"]) return;
  try {
    
if (!customElements.get('hs-acrylic-markers')) {
  customElements.define('hs-acrylic-markers', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.select = this.querySelector('[data-variant]');
      this.select.addEventListener('change', () => this.choose(this.select.value));
      this.querySelectorAll('[data-set]').forEach(button => button.addEventListener('click', () => { this.choose(button.dataset.set); this.select.focus({preventScroll:true}); this.querySelector('.amp-buy').scrollIntoView({block:'start'}); }));
      this.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
        const matches = this.variants.filter(v => String(v.image) === button.dataset.photo);
        if (matches.length === 1 && String(matches[0].id) !== this.select.value) this.choose(matches[0].id, false);
        this.showPhoto(button);
      }));
      this.onPop = () => { const id = new URL(location.href).searchParams.get('variant'); if (id) this.choose(id, true, false); };
      window.addEventListener('popstate', this.onPop);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); }
    showPhoto(button) {
      const img = this.querySelector('.amp-main-image');
      img.removeAttribute('srcset'); img.src = button.dataset.src; img.alt = button.dataset.alt;
      this.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }
    choose(id, changePhoto = true, changeUrl = true) {
      const variant = this.variants.find(v => String(v.id) === String(id)); if (!variant) return;
      this.select.value = String(variant.id);
      this.querySelector('[data-price]').textContent = variant.price;
      this.querySelector('[data-state]').textContent = variant.available ? this.labels.available : this.dataset.sold;
      const atc = this.querySelector('[data-atc]'); atc.disabled = !variant.available; atc.textContent = variant.available ? this.dataset.add : this.dataset.sold;
      this.querySelectorAll('[data-set]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.set === String(id))));
      if (changePhoto && variant.image) { const button = this.querySelector('[data-photo="' + variant.image + '"]'); if (button) this.showPhoto(button); }
      if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', String(id)); history.replaceState({}, '', url); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-apex-44"] && !Shopify.designMode) return;
  try {
    
function initNewPair0(root=document){root.querySelectorAll('[data-hs-apex-44]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-apex-44__hero-image');const thumbs=[...section.querySelectorAll('.hs-apex-44__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-apex-44-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initNewPair0();document.addEventListener('shopify:section:load',e=>initNewPair0(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-battery"] && !Shopify.designMode) return;
  try {
    
function initHsBattery(root=document){root.querySelectorAll('[data-hs-battery]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-battery__hero-image');const thumbs=[...section.querySelectorAll('.hs-battery__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-battery-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHsBattery();document.addEventListener('shopify:section:load',e=>initHsBattery(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-boxing-husky"]) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const image=root.querySelector('.draft-main-image');const select=root.querySelector('[data-variant]');const thumbs=[...root.querySelectorAll('[data-image-id][data-src]')].filter(e=>e.tagName==='BUTTON');const price=root.querySelector('[data-price]');const submit=root.querySelector('[data-submit]');function show(src,id,alt){if(!src||!image)return;image.removeAttribute('srcset');image.src=src;if(alt)image.alt=alt;thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.imageId===id)));}function sync(changeImage=true){const o=select.selectedOptions[0];price.textContent=o.dataset.price;submit.disabled=o.dataset.available!=='true';submit.textContent=submit.disabled?root.dataset.sold:root.dataset.add;if(changeImage)show(o.dataset.src,o.dataset.imageId,o.textContent);const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);}select.addEventListener('change',()=>sync());thumbs.forEach(b=>b.addEventListener('click',()=>{show(b.dataset.src,b.dataset.imageId,b.dataset.alt);const o=[...select.options].find(o=>o.dataset.imageId===b.dataset.imageId);if(o){select.value=o.value;sync(false);}}));const active=select.selectedOptions[0];if(active.dataset.src)show(active.dataset.src,active.dataset.imageId);else if(thumbs[0])thumbs[0].setAttribute('aria-pressed','true');}document.querySelectorAll('[data-draft-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-draft-page]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-brickbeat"] && !Shopify.designMode) return;
  try {
    
function initBrickBeat(root=document){root.querySelectorAll('[data-hs-brickbeat]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-brickbeat__hero-image');const thumbs=[...section.querySelectorAll('.hs-brickbeat__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-brickbeat-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initBrickBeat();document.addEventListener('shopify:section:load',e=>initBrickBeat(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-colororbit"] && !Shopify.designMode) return;
  try {
    
function initColorOrbit(root=document){root.querySelectorAll('[data-hs-colororbit]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-colororbit__hero-image');const thumbs=[...section.querySelectorAll('.hs-colororbit__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-colororbit-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initColorOrbit();document.addEventListener('shopify:section:load',e=>initColorOrbit(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-crackle-lantern"] && !Shopify.designMode) return;
  try {
    
function initCrackleLantern(root=document){root.querySelectorAll('[data-hs-crackle-lantern]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-crackle-lantern__hero-image');const thumbs=[...section.querySelectorAll('.hs-crackle-lantern__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-crackle-lantern-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initCrackleLantern();document.addEventListener('shopify:section:load',e=>initCrackleLantern(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-dreamwave"] && !Shopify.designMode) return;
  try {
    
function initHsdreamwave(root=document){root.querySelectorAll('[data-hs-dreamwave]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-dreamwave__hero-image');const thumbs=[...section.querySelectorAll('.hs-dreamwave__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-dreamwave-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHsdreamwave();document.addEventListener('shopify:section:load',e=>initHsdreamwave(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-embermist"] && !Shopify.designMode) return;
  try {
    
function initNewPair1(root=document){root.querySelectorAll('[data-hs-embermist]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-embermist__hero-image');const thumbs=[...section.querySelectorAll('.hs-embermist__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-embermist-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initNewPair1();document.addEventListener('shopify:section:load',e=>initNewPair1(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-faceflip"]) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const image=root.querySelector('.faceflip-main-image');const select=root.querySelector('[data-variant]');const thumbs=[...root.querySelectorAll('[data-image-id][data-src]')].filter(e=>e.tagName==='BUTTON');const price=root.querySelector('[data-price]');const submit=root.querySelector('[data-submit]');function show(src,id,alt){if(!src||!image)return;image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=src;if(alt)image.alt=alt;thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.imageId===id)));}function sync(changeImage=true){const o=select.selectedOptions[0];price.textContent=o.dataset.price;submit.disabled=o.dataset.available!=='true';submit.textContent=submit.disabled?root.dataset.sold:root.dataset.add;if(changeImage)show(o.dataset.src,o.dataset.imageId,o.textContent);const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);}select.addEventListener('change',()=>sync());window.addEventListener('popstate',()=>{const id=new URL(location.href).searchParams.get('variant');if(id&&[...select.options].some(o=>o.value===id)){select.value=id;sync();}});thumbs.forEach(b=>b.addEventListener('click',()=>{show(b.dataset.src,b.dataset.imageId,b.dataset.alt);const o=[...select.options].find(o=>o.dataset.imageId===b.dataset.imageId);if(o){select.value=o.value;sync(false);}}));const active=select.selectedOptions[0];if(active.dataset.src)show(active.dataset.src,active.dataset.imageId);else if(thumbs[0])thumbs[0].setAttribute('aria-pressed','true');}document.querySelectorAll('[data-faceflip-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-faceflip-page]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-fadecraft"]) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const image=root.querySelector('.fadecraft-main-image');const select=root.querySelector('[data-variant]');const thumbs=[...root.querySelectorAll('[data-image-id][data-src]')].filter(e=>e.tagName==='BUTTON');const price=root.querySelector('[data-price]');const submit=root.querySelector('[data-submit]');function show(src,id,alt){if(!src||!image)return;image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=src;if(alt)image.alt=alt;thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.imageId===id)));}function sync(changeImage=true){const o=select.selectedOptions[0];price.textContent=o.dataset.price;submit.disabled=o.dataset.available!=='true';submit.textContent=submit.disabled?root.dataset.sold:root.dataset.add;if(changeImage)show(o.dataset.src,o.dataset.imageId,o.textContent);const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);}select.addEventListener('change',()=>sync());window.addEventListener('popstate',()=>{const id=new URL(location.href).searchParams.get('variant');if(id&&[...select.options].some(o=>o.value===id)){select.value=id;sync();}});thumbs.forEach(b=>b.addEventListener('click',()=>{show(b.dataset.src,b.dataset.imageId,b.dataset.alt);const o=[...select.options].find(o=>o.dataset.imageId===b.dataset.imageId);if(o){select.value=o.value;sync(false);}}));const active=select.selectedOptions[0];if(active.dataset.src)show(active.dataset.src,active.dataset.imageId);else if(thumbs[0])thumbs[0].setAttribute('aria-pressed','true');}document.querySelectorAll('[data-fadecraft-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-fadecraft-page]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-fixpro117"] && !Shopify.designMode) return;
  try {
    
function initHsfixpro117(root=document){root.querySelectorAll('[data-hs-fixpro117]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-fixpro117__hero-image');const thumbs=[...section.querySelectorAll('.hs-fixpro117__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-fixpro117-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHsfixpro117();document.addEventListener('shopify:section:load',e=>initHsfixpro117(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-fresh-squeeze"] && !Shopify.designMode) return;
  try {
    
function initHsfreshsqueeze(root=document){root.querySelectorAll('[data-hs-fresh-squeeze]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-fresh-squeeze__hero-image');const thumbs=[...section.querySelectorAll('.hs-fresh-squeeze__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-fresh-squeeze-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHsfreshsqueeze();document.addEventListener('shopify:section:load',e=>initHsfreshsqueeze(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-honeyhaven-cat-cave-bed"] && !Shopify.designMode) return;
  try {
    
function initFive2(root=document){root.querySelectorAll('[data-hs-five-page-2]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-honeyhaven-cat-cave-bed__hero-image');const thumbs=[...section.querySelectorAll('.hs-honeyhaven-cat-cave-bed__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-five-page-2-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image){const thumb=thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src));if(thumb)show(thumb);else{hero.removeAttribute('srcset');hero.src=v.featured_image.src;hero.alt=v.featured_image.alt||'';thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));}}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);picker.dispatchEvent(new Event('change',{bubbles:true}));}show(t);}));sync(true);});}initFive2();document.addEventListener('shopify:section:load',e=>initFive2(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-jumbojoy-christmas-ornament"] && !Shopify.designMode) return;
  try {
    
function initFive0(root=document){root.querySelectorAll('[data-hs-five-page-0]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-jumbojoy-christmas-ornament__hero-image');const thumbs=[...section.querySelectorAll('.hs-jumbojoy-christmas-ornament__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-five-page-0-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image){const thumb=thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src));if(thumb)show(thumb);else{hero.removeAttribute('srcset');hero.src=v.featured_image.src;hero.alt=v.featured_image.alt||'';thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));}}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);picker.dispatchEvent(new Event('change',{bubbles:true}));}show(t);}));sync(true);});}initFive0();document.addEventListener('shopify:section:load',e=>initFive0(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-lige-meridian-chronograph-watch"] && !Shopify.designMode) return;
  try {
    
function initFive4(root=document){root.querySelectorAll('[data-hs-five-page-4]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-lige-meridian-chronograph-watch__hero-image');const thumbs=[...section.querySelectorAll('.hs-lige-meridian-chronograph-watch__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-five-page-4-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image){const thumb=thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src));if(thumb)show(thumb);else{hero.removeAttribute('srcset');hero.src=v.featured_image.src;hero.alt=v.featured_image.alt||'';thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));}}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);picker.dispatchEvent(new Event('change',{bubbles:true}));}show(t);}));sync(true);});}initFive4();document.addEventListener('shopify:section:load',e=>initFive4(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-magnetic-powerbank"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-powerbank')) {
  customElements.define('hs-powerbank', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-hp-data]').textContent);
      this.select = this.querySelector('[data-hp-variant]');
      this.mainImage = this.querySelector('.hp-main-image');
      this.thumbs = Array.from(this.querySelectorAll('[data-photo]'));
      this.select.addEventListener('change', () => this.setVariant(this.select.value, true));
      this.thumbs.forEach(button => button.addEventListener('click', () => {
        this.showImage(button);
        const associated = this.variants.find(v => String(v.imageId) === button.dataset.photo && String(v.id) === this.select.value) || this.variants.find(v => String(v.imageId) === button.dataset.photo);
        if (associated) this.setVariant(associated.id, false);
      }));
      const buy = this.querySelector('.hp-buy');
      const sticky = this.querySelector('.hp-sticky');
      this.observer = new IntersectionObserver(entries => {
        const visible = entries[0].isIntersecting;
        sticky.classList.toggle('hp-off', visible);
        sticky.inert = visible;
        sticky.setAttribute('aria-hidden', String(visible));
      }, {threshold:0});
      this.observer.observe(buy);
      this.querySelectorAll('a[href^="#hp-buy-"]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        buy.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        buy.focus({preventScroll:true});
      }));
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
    showImage(button) {
      this.mainImage.removeAttribute('srcset');
      this.mainImage.src = button.dataset.src;
      this.mainImage.alt = button.dataset.alt;
      this.thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === button)));
    }
    setVariant(id, changeImage) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.select.value = String(variant.id);
      this.querySelectorAll('[data-hp-price]').forEach(p => p.innerHTML = variant.price);
      const compare = this.querySelector('[data-hp-compare]');
      compare.innerHTML = variant.compare;
      compare.hidden = !variant.onSale;
      this.querySelectorAll('[data-hp-add]').forEach(b => b.disabled = !variant.available);
      this.querySelectorAll('[data-hp-add-label]').forEach(b => b.textContent = variant.available ? this.dataset.add : this.dataset.sold);
      this.querySelector('[data-hp-stock]').textContent = variant.available ? this.dataset.available : this.dataset.sold;
      if (changeImage && variant.imageId) {
        const thumb = this.thumbs.find(t => t.dataset.photo === String(variant.imageId));
        if (thumb) this.showImage(thumb);
      }
      const url = new URL(location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-meadow-muse"] && !Shopify.designMode) return;
  try {
    
function initHsmeadowmuse(root=document){root.querySelectorAll('[data-hs-meadow-muse]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-meadow-muse__hero-image');const thumbs=[...section.querySelectorAll('.hs-meadow-muse__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-meadow-muse-variants]').textContent);if(!picker||!hero)return;const optionControls=[...section.querySelectorAll('[data-dress-option]')];const controls=section.querySelector('[data-dress-options]');if(controls){controls.hidden=false;picker.hidden=true;const lab=section.querySelector('[data-canonical-label]');if(lab)lab.hidden=true;}const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;optionControls.forEach((control,i)=>control.value=v.options[i]);section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};optionControls.forEach(control=>control.addEventListener('change',()=>{const chosen=optionControls.map(x=>x.value);const v=variants.find(x=>x.options.every((value,i)=>value===chosen[i]));if(v){picker.value=String(v.id);sync();}}));picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const current=variants.find(v=>String(v.id)===picker.value);const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available&&v.options[0]===current?.options[0])||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHsmeadowmuse();document.addEventListener('shopify:section:load',e=>initHsmeadowmuse(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-midnight-coffin"] && !Shopify.designMode) return;
  try {
    
function initThree2(root=document){root.querySelectorAll('[data-hs-midnight-coffin]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-midnight-coffin__hero-image');const thumbs=[...section.querySelectorAll('.hs-midnight-coffin__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-midnight-coffin-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initThree2();document.addEventListener('shopify:section:load',e=>initThree2(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-monoform"] && !Shopify.designMode) return;
  try {
    
function initMonoForm(root=document){root.querySelectorAll('[data-hs-monoform]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-monoform__hero-image');const thumbs=[...section.querySelectorAll('.hs-monoform__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-monoform-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initMonoForm();document.addEventListener('shopify:section:load',e=>initMonoForm(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-october-product"] && !Shopify.designMode) return;
  try {
    
function initHsOctober(root=document){root.querySelectorAll('[data-hso]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hso__hero-image');const thumbs=[...section.querySelectorAll('.hso__thumb')];const variants=JSON.parse(section.querySelector('[data-hso-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync();});}initHsOctober();document.addEventListener('shopify:section:load',e=>initHsOctober(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-olevs-9915-horizon-watch"] && !Shopify.designMode) return;
  try {
    
function initFive1(root=document){root.querySelectorAll('[data-hs-five-page-1]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-olevs-9915-horizon-watch__hero-image');const thumbs=[...section.querySelectorAll('.hs-olevs-9915-horizon-watch__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-five-page-1-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image){const thumb=thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src));if(thumb)show(thumb);else{hero.removeAttribute('srcset');hero.src=v.featured_image.src;hero.alt=v.featured_image.alt||'';thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));}}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);picker.dispatchEvent(new Event('change',{bubbles:true}));}show(t);}));sync(true);});}initFive1();document.addEventListener('shopify:section:load',e=>initFive1(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pet-cowboy-hat"] && !Shopify.designMode) return;
  try {
    
function initHsPetHat(root=document){root.querySelectorAll('[data-hs-pethat]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-pethat__hero-image');const thumbs=[...section.querySelectorAll('.hs-pethat__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-pethat-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));if(new URL(location.href).searchParams.has('variant'))sync();});}initHsPetHat();document.addEventListener('shopify:section:load',e=>initHsPetHat(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pimple-patches"]) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const image=root.querySelector('.draft-main-image');const select=root.querySelector('[data-variant]');const thumbs=[...root.querySelectorAll('[data-image-id][data-src]')].filter(e=>e.tagName==='BUTTON');const price=root.querySelector('[data-price]');const submit=root.querySelector('[data-submit]');function show(src,id,alt){if(!src||!image)return;image.removeAttribute('srcset');image.src=src;if(alt)image.alt=alt;thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.imageId===id)));}function sync(changeImage=true){const o=select.selectedOptions[0];price.textContent=o.dataset.price;submit.disabled=o.dataset.available!=='true';submit.textContent=submit.disabled?root.dataset.sold:root.dataset.add;if(changeImage)show(o.dataset.src,o.dataset.imageId,o.textContent);const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);}select.addEventListener('change',()=>sync());thumbs.forEach(b=>b.addEventListener('click',()=>{show(b.dataset.src,b.dataset.imageId,b.dataset.alt);const o=[...select.options].find(o=>o.dataset.imageId===b.dataset.imageId);if(o){select.value=o.value;sync(false);}}));const active=select.selectedOptions[0];if(active.dataset.src)show(active.dataset.src,active.dataset.imageId);else if(thumbs[0])thumbs[0].setAttribute('aria-pressed','true');}document.querySelectorAll('[data-draft-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-draft-page]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pixel-torch"] && !Shopify.designMode) return;
  try {
    
function initThree1(root=document){root.querySelectorAll('[data-hs-pixel-torch]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-pixel-torch__hero-image');const thumbs=[...section.querySelectorAll('.hs-pixel-torch__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-pixel-torch-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initThree1();document.addEventListener('shopify:section:load',e=>initThree1(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pocketedit-wallet"] && !Shopify.designMode) return;
  try {
    
function initHspocketeditwallet(root=document){root.querySelectorAll('[data-hs-pocketedit-wallet]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-pocketedit-wallet__hero-image');const thumbs=[...section.querySelectorAll('.hs-pocketedit-wallet__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-pocketedit-wallet-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHspocketeditwallet();document.addEventListener('shopify:section:load',e=>initHspocketeditwallet(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-poedagar-boardroom-calendar-watch"] && !Shopify.designMode) return;
  try {
    
function initFive3(root=document){root.querySelectorAll('[data-hs-five-page-3]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-poedagar-boardroom-calendar-watch__hero-image');const thumbs=[...section.querySelectorAll('.hs-poedagar-boardroom-calendar-watch__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-five-page-3-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image){const thumb=thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src));if(thumb)show(thumb);else{hero.removeAttribute('srcset');hero.src=v.featured_image.src;hero.alt=v.featured_image.alt||'';thumbs.forEach(t=>t.setAttribute('aria-pressed','false'));}}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);picker.dispatchEvent(new Event('change',{bubbles:true}));}show(t);}));sync(true);});}initFive3();document.addEventListener('shopify:section:load',e=>initFive3(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-power-reel"] && !Shopify.designMode) return;
  try {
    
function initHsPowerReel(root=document){root.querySelectorAll('[data-hspr]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hso__hero-image');const thumbs=[...section.querySelectorAll('.hso__thumb')];const variants=JSON.parse(section.querySelector('[data-hspr-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync();});}initHsPowerReel();document.addEventListener('shopify:section:load',e=>initHsPowerReel(e.target));

function initHsoAddon(scope=document){
 scope.querySelectorAll('[data-hspr]').forEach(section=>{
  const addon=section.querySelector('[data-reel-addon]');
  const form=section.querySelector('[data-buy-form]');
  if(!addon||!form||addon.dataset.ready==='yes')return;
  const check=addon.querySelector('[data-addon-check]');
  const select=addon.querySelector('[data-addon-variant]');
  const qty=form.querySelector('input[name="quantity"]');
  const reelId=form.querySelector('[name="id"]');
  const button=form.querySelector('[data-buy-atc]');
  if(!check||!select||!qty||!reelId||!button)return;
  addon.dataset.ready='yes';
  const label=button.querySelector('[data-buy-atc-label]');
  const total=addon.querySelector('[data-addon-total]');
  const error=addon.querySelector('[data-addon-error]');
  const fast=section.querySelector('.hso__fast');
  const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
  const base=Number(section.dataset.priceCents);
  const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
  function sync(){
   select.disabled=!check.checked;
   if(fast)fast.hidden=check.checked;
   if(label)label.textContent=check.checked?'Add reel + batteries':'Add to cart';
   const quantity=Math.max(1,parseInt(qty.value,10)||1);
   const battery=check.checked?Number(select.selectedOptions[0]?.dataset.cents||0):0;
   total.textContent=check.checked?'Combined total: '+money.format((base*quantity+battery)/100):'';
   error.hidden=true;
  }
  check.addEventListener('change',sync);select.addEventListener('change',sync);qty.addEventListener('input',sync);
  form.addEventListener('submit',async event=>{
   if(!check.checked)return;
   event.preventDefault();event.stopImmediatePropagation();
   const reel=Number(reelId.value), battery=Number(select.value),quantity=Math.max(1,parseInt(qty.value,10)||1);
   if(!reel||!battery)return;
   button.disabled=true;if(label)label.textContent='Adding your kit…';error.hidden=true;
   try{
    const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:reel,quantity},{id:battery,quantity:1}]})});
    if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.description||data.message||'Could not add both products');}
    window.location.assign(root+'cart');
   }catch(ex){error.textContent=(ex?.message||'Could not add both products')+'. Try again, or add the batteries separately.';error.hidden=false;button.disabled=false;if(label)label.textContent='Add reel + batteries';}
  },true);
  sync();
 });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initHsoAddon(),{once:true});}else{initHsoAddon();}
document.addEventListener('shopify:section:load',e=>initHsoAddon(e.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pumpkin-glow"] && !Shopify.designMode) return;
  try {
    
function initThree0(root=document){root.querySelectorAll('[data-hs-pumpkin-glow]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-pumpkin-glow__hero-image');const thumbs=[...section.querySelectorAll('.hs-pumpkin-glow__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-pumpkin-glow-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initThree0();document.addEventListener('shopify:section:load',e=>initThree0(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pumpkin-party"] && !Shopify.designMode) return;
  try {
    
function initHspumpkinparty(root=document){root.querySelectorAll('[data-hs-pumpkin-party]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-pumpkin-party__hero-image');const thumbs=[...section.querySelectorAll('.hs-pumpkin-party__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-pumpkin-party-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHspumpkinparty();document.addEventListener('shopify:section:load',e=>initHspumpkinparty(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-rebel-clutch"] && !Shopify.designMode) return;
  try {
    
function initRebelClutch(root=document){root.querySelectorAll('[data-hs-rebel-clutch]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-rebel-clutch__hero-image');const thumbs=[...section.querySelectorAll('.hs-rebel-clutch__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-rebel-clutch-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initRebelClutch();document.addEventListener('shopify:section:load',e=>initRebelClutch(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-sketchlab29"] && !Shopify.designMode) return;
  try {
    
function initHssketchlab29(root=document){root.querySelectorAll('[data-hs-sketchlab29]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-sketchlab29__hero-image');const thumbs=[...section.querySelectorAll('.hs-sketchlab29__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-sketchlab29-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHssketchlab29();document.addEventListener('shopify:section:load',e=>initHssketchlab29(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-skyloop"] && !Shopify.designMode) return;
  try {
    
function initSkyLoop(root=document){root.querySelectorAll('[data-hs-skyloop]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-skyloop__hero-image');const thumbs=[...section.querySelectorAll('.hs-skyloop__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-skyloop-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initSkyLoop();document.addEventListener('shopify:section:load',e=>initSkyLoop(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-spinstage"] && !Shopify.designMode) return;
  try {
    
function initHsSpinStage(root=document){root.querySelectorAll('[data-hs-spin]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-spin__hero-image');const thumbs=[...section.querySelectorAll('.hs-spin__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-spin-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync();});}initHsSpinStage();document.addEventListener('shopify:section:load',e=>initHsSpinStage(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-spiraltwist"] && !Shopify.designMode) return;
  try {
    
function initHsspiraltwist(root=document){root.querySelectorAll('[data-hs-spiraltwist]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-spiraltwist__hero-image');const thumbs=[...section.querySelectorAll('.hs-spiraltwist__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-spiraltwist-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initHsspiraltwist();document.addEventListener('shopify:section:load',e=>initHsspiraltwist(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-splashdrive"] && !Shopify.designMode) return;
  try {
    
function initSplashDrive(root=document){root.querySelectorAll('[data-hs-splashdrive]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const picker=section.querySelector('[data-buy-variant]');const hero=section.querySelector('.hs-splashdrive__hero-image');const thumbs=[...section.querySelectorAll('.hs-splashdrive__thumb')];const variants=JSON.parse(section.querySelector('[data-hs-splashdrive-variants]').textContent);if(!picker||!hero)return;const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});const norm=u=>String(u||'').split('?')[0].replace(/^https?:/,'');const show=t=>{if(!t)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=t.dataset.image;hero.alt=t.dataset.alt;thumbs.forEach(x=>x.setAttribute('aria-pressed',String(x===t)));};const sync=(image=true)=>{const v=variants.find(x=>String(x.id)===picker.value);if(!v)return;section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;section.querySelector('[data-buy-atc]').disabled=!v.available;section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;if(image&&v.featured_image)show(thumbs.find(t=>norm(t.dataset.image)===norm(v.featured_image.src)));const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};picker.addEventListener('change',()=>sync());thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&norm(v.featured_image.src)===norm(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}show(t);}));sync(new URL(location.href).searchParams.has('variant')||variants.length>1);});}initSplashDrive();document.addEventListener('shopify:section:load',e=>initSplashDrive(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-travel-pillow"]) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const image=root.querySelector('.draft-main-image');const select=root.querySelector('[data-variant]');const thumbs=[...root.querySelectorAll('[data-image-id][data-src]')].filter(e=>e.tagName==='BUTTON');const price=root.querySelector('[data-price]');const submit=root.querySelector('[data-submit]');function show(src,id,alt){if(!src||!image)return;image.removeAttribute('srcset');image.src=src;if(alt)image.alt=alt;thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.imageId===id)));}function sync(changeImage=true){const o=select.selectedOptions[0];price.textContent=o.dataset.price;submit.disabled=o.dataset.available!=='true';submit.textContent=submit.disabled?root.dataset.sold:root.dataset.add;if(changeImage)show(o.dataset.src,o.dataset.imageId,o.textContent);const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);}select.addEventListener('change',()=>sync());thumbs.forEach(b=>b.addEventListener('click',()=>{show(b.dataset.src,b.dataset.imageId,b.dataset.alt);const o=[...select.options].find(o=>o.dataset.imageId===b.dataset.imageId);if(o){select.value=o.value;sync(false);}}));const active=select.selectedOptions[0];if(active.dataset.src)show(active.dataset.src,active.dataset.imageId);else if(thumbs[0])thumbs[0].setAttribute('aria-pressed','true');}document.querySelectorAll('[data-draft-page]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-draft-page]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-watch-1901"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-watch-1901')) {
  customElements.define('hs-watch-1901', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-h1901-data]').textContent);
      this.select = this.querySelector('[data-h1901-variant]');
      this.mainImage = this.querySelector('.h1901-main-image');
      this.thumbs = Array.from(this.querySelectorAll('[data-photo]'));
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.select.addEventListener('change', () => this.setVariant(this.select.value, true), options);
      this.thumbs.forEach(button => button.addEventListener('click', () => {
        this.showImage(button);
        const associated = this.variants.find(v => String(v.imageId) === button.dataset.photo && String(v.id) === this.select.value) || this.variants.find(v => String(v.imageId) === button.dataset.photo);
        if (associated) this.setVariant(associated.id, false);
      }, options));
      const buy = this.querySelector('.h1901-buy');
      const sticky = this.querySelector('.h1901-sticky');
      this.observer = new IntersectionObserver(entries => {
        const visible = entries[0].isIntersecting;
        sticky.classList.toggle('h1901-off', visible);
        sticky.inert = visible;
        sticky.setAttribute('aria-hidden', String(visible));
      }, {threshold:0});
      this.observer.observe(buy);
      this.querySelectorAll('a[href^="#h1901-buy-"]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        if(link.dataset.pick) this.setVariant(link.dataset.pick,true);
        buy.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        buy.focus({preventScroll:true});
      }, options));
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        if(id) this.setVariant(id,true,false);
      }, options);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.ready = false; }
    showImage(button) {
      this.mainImage.removeAttribute('srcset');
      this.mainImage.src = button.dataset.src;
      this.mainImage.alt = button.dataset.alt;
      this.thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === button)));
    }
    setVariant(id, changeImage, updateUrl = true) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.select.value = String(variant.id);
      this.querySelectorAll('[data-h1901-price]').forEach(p => p.innerHTML = variant.price);
      const compare = this.querySelector('[data-h1901-compare]');
      compare.innerHTML = variant.compare;
      compare.hidden = !variant.onSale;
      this.querySelectorAll('[data-h1901-add]').forEach(b => b.disabled = !variant.available);
      this.querySelectorAll('[data-h1901-add-label]').forEach(b => b.textContent = variant.available ? this.dataset.add : this.dataset.sold);
      this.querySelector('[data-h1901-stock]').textContent = variant.available ? this.dataset.available : this.dataset.sold;
      this.querySelector('[data-h1901-selection]').textContent = variant.title;
      if (changeImage && variant.imageId) {
        const thumb = this.thumbs.find(t => t.dataset.photo === String(variant.imageId));
        if (thumb) this.showImage(thumb);
      }
      if(updateUrl){
        const url = new URL(location.href);
        url.searchParams.set('variant',variant.id);
        history.replaceState({},'',url);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hype-chocolate-bar-squishy"] && !Shopify.designMode) return;
  try {
    

function initSquishyTrio(scope=document){
scope.querySelectorAll('[data-sqt]').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const variants=JSON.parse(section.querySelector('[data-variants]').textContent);
const picker=section.querySelector('[data-buy-variant]');
const thumbs=[...section.querySelectorAll('[data-image]')];
const hero=section.querySelector('.sqt__hero-image');
const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
const normalize=v=>String(v||'').split('?')[0].replace(/^https?:/,'');
const showImage=thumb=>{if(!thumb||!hero)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=thumb.dataset.image;hero.alt=thumb.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));};
const sync=(changeImage=true)=>{
const v=variants.find(v=>String(v.id)===picker.value);if(!v)return;
section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);
section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;
section.querySelector('[data-buy-atc]').disabled=!v.available;
section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;
section.querySelectorAll('[data-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pick===picker.value)));
if(changeImage&&v.featured_image){showImage(thumbs.find(t=>normalize(t.dataset.image)===normalize(v.featured_image.src)));}
const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
};
picker.addEventListener('change',()=>sync());
thumbs.forEach(t=>t.addEventListener('click',()=>{
const matches=variants.filter(v=>v.featured_image&&normalize(v.featured_image.src)===normalize(t.dataset.image));
const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];
if(linked){picker.value=String(linked.id);sync(false);}showImage(t);
}));
section.querySelectorAll('[data-pick]').forEach(b=>b.addEventListener('click',()=>{picker.value=b.dataset.pick;sync();section.querySelector('.sqt__buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}));
sync();
});}
initSquishyTrio();document.addEventListener('shopify:section:load',e=>initSquishyTrio(e.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hype-dancing-cactus"] && !Shopify.designMode) return;
  try {
    
function initDancingCactus(scope=document){
scope.querySelectorAll('[data-dct]').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const variants=JSON.parse(section.querySelector('[data-variants]').textContent);
const picker=section.querySelector('[data-buy-variant]');
const thumbs=[...section.querySelectorAll('[data-image]')];
const hero=section.querySelector('.dct__hero-image');
if(!picker||!hero)return;
const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
const normalize=v=>String(v||'').split('?')[0].replace(/^https?:/,'');
const showImage=thumb=>{if(!thumb)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=thumb.dataset.image;hero.alt=thumb.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));};
const sync=(changeImage=true)=>{const v=variants.find(v=>String(v.id)===picker.value);if(!v)return;const p=section.querySelector('[data-buy-price]');if(p)p.textContent=money.format(v.price/100);const a=section.querySelector('[data-buy-availability]');if(a)a.textContent=v.available?section.dataset.stock:section.dataset.sold;const b=section.querySelector('[data-buy-atc]');if(b)b.disabled=!v.available;const l=section.querySelector('[data-buy-atc-label]');if(l)l.textContent=v.available?section.dataset.add:section.dataset.sold;if(changeImage&&v.featured_image){showImage(thumbs.find(t=>normalize(t.dataset.image)===normalize(v.featured_image.src)));}const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);};
picker.addEventListener('change',()=>sync());
thumbs.forEach(t=>t.addEventListener('click',()=>{const matches=variants.filter(v=>v.featured_image&&normalize(v.featured_image.src)===normalize(t.dataset.image));const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];if(linked){picker.value=String(linked.id);sync(false);}showImage(t);}));
sync();
});}
initDancingCactus();document.addEventListener('shopify:section:load',e=>initDancingCactus(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hype-gumdrop-fidget"] && !Shopify.designMode) return;
  try {
    

function initSquishyTrio(scope=document){
scope.querySelectorAll('[data-sqt]').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const variants=JSON.parse(section.querySelector('[data-variants]').textContent);
const picker=section.querySelector('[data-buy-variant]');
const thumbs=[...section.querySelectorAll('[data-image]')];
const hero=section.querySelector('.sqt__hero-image');
const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
const normalize=v=>String(v||'').split('?')[0].replace(/^https?:/,'');
const showImage=thumb=>{if(!thumb||!hero)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=thumb.dataset.image;hero.alt=thumb.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));};
const sync=(changeImage=true)=>{
const v=variants.find(v=>String(v.id)===picker.value);if(!v)return;
section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);
section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;
section.querySelector('[data-buy-atc]').disabled=!v.available;
section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;
section.querySelectorAll('[data-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pick===picker.value)));
if(changeImage&&v.featured_image){showImage(thumbs.find(t=>normalize(t.dataset.image)===normalize(v.featured_image.src)));}
const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
};
picker.addEventListener('change',()=>sync());
thumbs.forEach(t=>t.addEventListener('click',()=>{
const matches=variants.filter(v=>v.featured_image&&normalize(v.featured_image.src)===normalize(t.dataset.image));
const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];
if(linked){picker.value=String(linked.id);sync(false);}showImage(t);
}));
section.querySelectorAll('[data-pick]').forEach(b=>b.addEventListener('click',()=>{picker.value=b.dataset.pick;sync();section.querySelector('.sqt__buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}));
sync();
});}
initSquishyTrio();document.addEventListener('shopify:section:load',e=>initSquishyTrio(e.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hype-rainbow-butter-squishy"] && !Shopify.designMode) return;
  try {
    

function initSquishyTrio(scope=document){
scope.querySelectorAll('[data-sqt]').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const variants=JSON.parse(section.querySelector('[data-variants]').textContent);
const picker=section.querySelector('[data-buy-variant]');
const thumbs=[...section.querySelectorAll('[data-image]')];
const hero=section.querySelector('.sqt__hero-image');
const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
const normalize=v=>String(v||'').split('?')[0].replace(/^https?:/,'');
const showImage=thumb=>{if(!thumb||!hero)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=thumb.dataset.image;hero.alt=thumb.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));};
const sync=(changeImage=true)=>{
const v=variants.find(v=>String(v.id)===picker.value);if(!v)return;
section.querySelector('[data-buy-price]').textContent=money.format(v.price/100);
section.querySelector('[data-buy-availability]').textContent=v.available?section.dataset.stock:section.dataset.sold;
section.querySelector('[data-buy-atc]').disabled=!v.available;
section.querySelector('[data-buy-atc-label]').textContent=v.available?section.dataset.add:section.dataset.sold;
section.querySelectorAll('[data-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pick===picker.value)));
if(changeImage&&v.featured_image){showImage(thumbs.find(t=>normalize(t.dataset.image)===normalize(v.featured_image.src)));}
const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
};
picker.addEventListener('change',()=>sync());
thumbs.forEach(t=>t.addEventListener('click',()=>{
const matches=variants.filter(v=>v.featured_image&&normalize(v.featured_image.src)===normalize(t.dataset.image));
const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];
if(linked){picker.value=String(linked.id);sync(false);}showImage(t);
}));
section.querySelectorAll('[data-pick]').forEach(b=>b.addEventListener('click',()=>{picker.value=b.dataset.pick;sync();section.querySelector('.sqt__buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}));
sync();
});}
initSquishyTrio();document.addEventListener('shopify:section:load',e=>initSquishyTrio(e.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hype-spiral-glow"] && !Shopify.designMode) return;
  try {
    
function initSpiralGlow(scope=document){
scope.querySelectorAll('[data-sgl]').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const variants=JSON.parse(section.querySelector('[data-sgl-variants]').textContent);
const picker=section.querySelector('[data-buy-variant]');
const thumbs=[...section.querySelectorAll('[data-image]')];
const hero=section.querySelector('.sgl__hero-image');
if(!picker||!hero)return;
const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
const normalize=v=>String(v||'').split('?')[0].replace(/^https?:/,'');
const showImage=thumb=>{if(!thumb)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=thumb.dataset.image;hero.alt=thumb.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));};
const sync=(changeImage=true)=>{
const v=variants.find(v=>String(v.id)===picker.value);if(!v)return;
const price=section.querySelector('[data-buy-price]');if(price)price.textContent=money.format(v.price/100);
const availability=section.querySelector('[data-buy-availability]');if(availability)availability.textContent=v.available?section.dataset.stock:section.dataset.sold;
const button=section.querySelector('[data-buy-atc]');if(button)button.disabled=!v.available;
const label=section.querySelector('[data-buy-atc-label]');if(label)label.textContent=v.available?section.dataset.add:section.dataset.sold;
if(changeImage&&v.featured_image){showImage(thumbs.find(t=>normalize(t.dataset.image)===normalize(v.featured_image.src)));}
const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
};
picker.addEventListener('change',()=>sync());
thumbs.forEach(t=>t.addEventListener('click',()=>{
const matches=variants.filter(v=>v.featured_image&&normalize(v.featured_image.src)===normalize(t.dataset.image));
const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];
if(linked){picker.value=String(linked.id);sync(false);}
showImage(t);
}));
sync();
});}
initSpiralGlow();document.addEventListener('shopify:section:load',e=>initSpiralGlow(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jinglesprout-tree-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.jspr').forEach((root)=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const picker=root.querySelector('[data-jspr-variant]');
  const main=root.querySelector('.jspr__main');
  const thumbs=Array.from(root.querySelectorAll('.jspr__thumb'));
  const price=root.querySelector('[data-jspr-price]');
  const add=root.querySelector('[data-jspr-add]');
  const addLabel=root.querySelector('[data-jspr-add-label]');
  if(!picker)return;
  const show=(url,alt,thumb)=>{if(main&&url){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;if(alt)main.alt=alt}thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb))};
  const update=()=>{const option=picker.options[picker.selectedIndex];if(!option)return;if(price)price.textContent=option.dataset.price||'';const ok=option.dataset.available==='true';if(add)add.disabled=!ok;if(addLabel)addLabel.textContent=ok?'Bring home a JingleSprout':'Sold out';const thumb=thumbs.find(t=>t.dataset.mediaId===option.dataset.mediaId);if(thumb)show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb);else if(option.dataset.imageUrl)show(option.dataset.imageUrl,option.dataset.imageAlt,null)};
  picker.addEventListener('change',update);
  thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{const linked=thumb.dataset.variantId;const option=linked?Array.from(picker.options).find(o=>o.value===linked):null;if(option){picker.value=linked;picker.dispatchEvent(new Event('change',{bubbles:true}))}else{show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb)}}));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["johnny-5-robot-landing"] && !Shopify.designMode) return;
  try {
    
function initJohnnyFive(scope=document){
scope.querySelectorAll('[data-j5]').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const variants=JSON.parse(section.querySelector('[data-j5-variants]').textContent);
const picker=section.querySelector('[data-buy-variant]');
const thumbs=[...section.querySelectorAll('[data-image]')];
const hero=section.querySelector('.j5__hero-image');
if(!picker||!hero)return;
const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
const normalize=v=>String(v||'').split('?')[0].replace(/^https?:/,'');
const showImage=thumb=>{if(!thumb)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=thumb.dataset.image;hero.alt=thumb.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));};
const sync=(changeImage=true)=>{
const v=variants.find(v=>String(v.id)===picker.value);if(!v)return;
const price=section.querySelector('[data-buy-price]');if(price)price.textContent=money.format(v.price/100);
const availability=section.querySelector('[data-buy-availability]');if(availability)availability.textContent=v.available?section.dataset.stock:section.dataset.sold;
const button=section.querySelector('[data-buy-atc]');if(button)button.disabled=!v.available;
const label=section.querySelector('[data-buy-atc-label]');if(label)label.textContent=v.available?section.dataset.add:section.dataset.sold;
if(changeImage&&v.featured_image){showImage(thumbs.find(t=>normalize(t.dataset.image)===normalize(v.featured_image.src)));}
const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
};
picker.addEventListener('change',()=>sync());
thumbs.forEach(t=>t.addEventListener('click',()=>{
const matches=variants.filter(v=>v.featured_image&&normalize(v.featured_image.src)===normalize(t.dataset.image));
const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];
if(linked){picker.value=String(linked.id);sync(false);}
showImage(t);
}));
sync();
});}
initJohnnyFive();document.addEventListener('shopify:section:load',e=>initJohnnyFive(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunar-crown-olevs-3655"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lc').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const picker=root.querySelector('[data-lc-variant]'),main=root.querySelector('.lc__main'),thumbs=[...root.querySelectorAll('.lc__thumb')],price=root.querySelector('[data-lc-price]'),compare=root.querySelector('[data-lc-compare]'),add=root.querySelector('[data-lc-add]'),label=root.querySelector('[data-lc-label]');if(!picker)return;const show=(url,alt,thumb)=>{if(main&&url){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;if(alt)main.alt=alt}thumbs.forEach(t=>t.classList.remove('is-active'));if(thumb)thumb.classList.add('is-active')};picker.addEventListener('change',()=>{const o=picker.options[picker.selectedIndex];if(price)price.textContent=o.dataset.price||'';if(compare){compare.textContent=o.dataset.compare||'';compare.style.display=o.dataset.hasCompare==='true'?'':'none'}const ok=o.dataset.available==='true';if(add)add.disabled=!ok;if(label)label.textContent=ok?'Add Lunar Crown':'Sold out';const t=thumbs.find(x=>x.dataset.media===o.dataset.media);if(t)show(t.dataset.url,t.dataset.alt,t);else if(o.dataset.url)show(o.dataset.url,o.dataset.alt,null)});thumbs.forEach(t=>t.addEventListener('click',()=>{if(t.dataset.variant&&[...picker.options].some(o=>o.value===t.dataset.variant)){picker.value=t.dataset.variant;picker.dispatchEvent(new Event('change',{bubbles:true}))}else show(t.dataset.url,t.dataset.alt,t)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-can-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',function(event){
    const thumb=event.target.closest('.magic-can__thumb');
    if(!thumb)return;
    const section=thumb.closest('.magic-can');
    const main=section.querySelector('.magic-can__main-image');
    if(!main)return;
    section.querySelectorAll('.magic-can__thumb').forEach(function(button){button.classList.remove('is-active');button.setAttribute('aria-pressed','false')});
    thumb.classList.add('is-active');thumb.setAttribute('aria-pressed','true');
    main.classList.add('is-changing');
    main.addEventListener('load',function(){main.classList.remove('is-changing')},{once:true});
    main.addEventListener('error',function(){main.classList.remove('is-changing')},{once:true});
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.alt=thumb.dataset.imageAlt;
    main.src=thumb.dataset.imageUrl;
  });

  function initMagicCanInstructionalVideo(){
    document.querySelectorAll('.magic-can').forEach(function(section){
      const image=section.querySelector('.magic-can__video-payload');
      const video=section.querySelector('.magic-can__instructional-video');
      const status=section.querySelector('.magic-can__video-status');
      if(!image||!video||video.dataset.ready==='true')return;
      function decodeVideo(){
        try{
          const canvas=document.createElement('canvas');
          canvas.width=image.naturalWidth;
          canvas.height=image.naturalHeight;
          const context=canvas.getContext('2d',{willReadFrequently:true});
          context.drawImage(image,0,0);
          const rgba=context.getImageData(0,0,canvas.width,canvas.height).data;
          const packed=new Uint8Array(canvas.width*canvas.height*3);
          let j=0;
          for(let i=0;i<rgba.length;i+=4){
            packed[j++]=rgba[i];
            packed[j++]=rgba[i+1];
            packed[j++]=rgba[i+2];
          }
          const length=new DataView(packed.buffer).getUint32(0,false);
          if(length<1||length>packed.length-4)throw new Error('Invalid video payload');
          const blob=new Blob([packed.slice(4,4+length)],{type:'video/mp4'});
          video.src=URL.createObjectURL(blob);
          video.dataset.ready='true';
          video.load();
          if(status)status.textContent='';
        }catch(error){
          if(status)status.textContent='The instructional video could not load. Please refresh and try again.';
        }
      }
      if(image.complete&&image.naturalWidth){
        decodeVideo();
      }else{
        image.addEventListener('load',decodeVideo,{once:true});
        image.addEventListener('error',function(){
          if(status)status.textContent='The instructional video could not load. Please refresh and try again.';
        },{once:true});
      }
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initMagicCanInstructionalVideo,{once:true});
  }else{
    initMagicCanInstructionalVideo();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-spoon-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const thumb=event.target.closest('.magic-spoon__thumb');if(!thumb)return;const root=thumb.closest('.magic-spoon');const main=root?.querySelector('.magic-spoon__main-image');if(!main)return;root.querySelectorAll('.magic-spoon__thumb').forEach(button=>{button.classList.remove('is-active');button.setAttribute('aria-pressed','false')});thumb.classList.add('is-active');thumb.setAttribute('aria-pressed','true');main.classList.add('is-changing');main.addEventListener('load',()=>main.classList.remove('is-changing'),{once:true});main.addEventListener('error',()=>main.classList.remove('is-changing'),{once:true});main.removeAttribute('srcset');main.removeAttribute('sizes');main.alt=thumb.dataset.spoonAlt||'';main.src=thumb.dataset.spoonImg});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mens-stretch-cargo-joggers"] && !Shopify.designMode) return;
  try {
    
function initCargoJoggers(scope=document){
scope.querySelectorAll('[data-cj]').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const variants=JSON.parse(section.querySelector('[data-cj-variants]').textContent);
const picker=section.querySelector('[data-buy-variant]');
const thumbs=[...section.querySelectorAll('[data-image]')];
const hero=section.querySelector('.cj__hero-image');
if(!picker||!hero)return;
const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
const normalize=v=>String(v||'').split('?')[0].replace(/^https?:/,'');
const showImage=thumb=>{if(!thumb)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=thumb.dataset.image;hero.alt=thumb.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));};
const sync=(changeImage=true)=>{
const v=variants.find(v=>String(v.id)===picker.value);if(!v)return;
const price=section.querySelector('[data-buy-price]');if(price)price.textContent=money.format(v.price/100);
const availability=section.querySelector('[data-buy-availability]');if(availability)availability.textContent=v.available?section.dataset.stock:section.dataset.sold;
const button=section.querySelector('[data-buy-atc]');if(button)button.disabled=!v.available;
const label=section.querySelector('[data-buy-atc-label]');if(label)label.textContent=v.available?section.dataset.add:section.dataset.sold;
if(changeImage&&v.featured_image){showImage(thumbs.find(t=>normalize(t.dataset.image)===normalize(v.featured_image.src)));}
const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
};
picker.addEventListener('change',()=>sync());
thumbs.forEach(t=>t.addEventListener('click',()=>{
const matches=variants.filter(v=>v.featured_image&&normalize(v.featured_image.src)===normalize(t.dataset.image));
const linked=matches.find(v=>String(v.id)===picker.value)||matches.find(v=>v.available)||matches[0];
if(linked){picker.value=String(linked.id);sync(false);}
showImage(t);
}));
sync();
});}
initCargoJoggers();document.addEventListener('shopify:section:load',e=>initCargoJoggers(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["military-mini-charm"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mbc-section]').forEach((root) => {
    const mainImage = root.querySelector('.mbc__hero-image');
    const select = root.querySelector('[data-buy-variant]');
    const form = root.querySelector('[data-buy-form]');
    const price = root.querySelector('[data-buy-price]');
    const availability = root.querySelector('[data-buy-availability]');
    const mobilePrice = root.querySelector('[data-mbc-mobile-price]');
    const atc = root.querySelector('[data-buy-atc]');
    const atcLabel = root.querySelector('[data-buy-atc-label]');
    const mobileAdd = root.querySelector('[data-mbc-mobile-add]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-mbc-variants]')?.textContent || '[]'); } catch(e) {}

    const money = (cents) => {
      const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(cents/100); }
      catch(e){ return '$' + (cents/100).toFixed(2); }
    };

    const updateVariant = (id) => {
      const variant = variants.find((item) => String(item.id) === String(id));
      if (!variant) return;
      if (select) select.value = String(variant.id);
      const formatted = money(variant.price);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      if (availability) availability.textContent = variant.available ? 'In stock' : 'Sold out';
      if (atc) atc.disabled = !variant.available;
      if (mobileAdd) mobileAdd.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      const mediaId = variant.featured_media ? String(variant.featured_media.id) : '';
      const matchingThumb = mediaId ? Array.from(root.querySelectorAll('[data-mbc-img]')).find((btn) => String(btn.dataset.mediaId) === mediaId) : null;
      if (matchingThumb && mainImage) {
        mainImage.src = matchingThumb.dataset.mbcImg;
        mainImage.alt = matchingThumb.dataset.mbcAlt || '';
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-mbc-img]').forEach((btn) => btn.classList.toggle('is-active', btn === matchingThumb));
      } else if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch(e) {}
    };

    root.querySelectorAll('[data-mbc-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.mbcImg;
        mainImage.alt = btn.dataset.mbcAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-mbc-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
      const linked = variants.find((variant) => variant.featured_media && String(variant.featured_media.id) === String(btn.dataset.mediaId));
      if (linked) updateVariant(linked.id);
    }));

    select?.addEventListener('change', () => updateVariant(select.value));
    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monster-plush-keychain-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mpk-section]').forEach((root) => {
    const mainImage = root.querySelector('.mpk__hero-image');
    const select = root.querySelector('[data-mpk-variant]');
    const form = root.querySelector('[data-mpk-form]');
    const price = root.querySelector('[data-mpk-price]');
    const mobilePrice = root.querySelector('[data-mpk-mobile-price]');
    const atc = root.querySelector('[data-mpk-atc]');
    const atcLabel = root.querySelector('[data-mpk-atc-label]');
    const mobileAdd = root.querySelector('[data-mpk-mobile-add]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-mpk-variants]')?.textContent || '[]'); } catch(e) {}

    const money = (cents) => {
      try { return new Intl.NumberFormat(undefined,{style:'currency',currency:'{{ cart.currency.iso_code }}'}).format(cents/100); }
      catch(e){ return '$' + (cents/100).toFixed(2); }
    };

    const updateVariant = (id) => {
      const variant = variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      if (select) select.value = String(variant.id);
      const formatted = money(variant.price);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      if (atc) atc.disabled = !variant.available;
      if (mobileAdd) mobileAdd.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch(e) {}
    };

    root.querySelectorAll('[data-mpk-pick]').forEach(btn => btn.addEventListener('click', () => {
      updateVariant(btn.dataset.mpkPick);
      root.querySelector('.mpk__buy')?.scrollIntoView({behavior:'smooth',block:'center'});
    }));

    root.querySelectorAll('[data-mpk-img]').forEach(btn => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.mpkImg;
        mainImage.alt = btn.dataset.mpkAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-mpk-img]').forEach(x => x.classList.remove('is-active'));
      btn.classList.add('is-active');
      const mediaId = String(btn.dataset.mediaId || '');
      const linked = variants.find(v => v.featured_media && String(v.featured_media.id) === mediaId);
      if (linked) updateVariant(linked.id);
    }));

    select?.addEventListener('change', () => updateVariant(select.value));
    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noirshift-watch-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ns').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const main=root.querySelector('.ns__main'),thumbs=[...root.querySelectorAll('.ns__thumb')];thumbs.forEach(t=>t.addEventListener('click',()=>{thumbs.forEach(x=>x.classList.remove('is-active'));t.classList.add('is-active');if(main){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=t.dataset.url;main.alt=t.dataset.alt||main.alt}}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinbench-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pnb').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const main=root.querySelector('.pnb__main');
  const thumbs=Array.from(root.querySelectorAll('.pnb__thumb'));
  thumbs.forEach((thumb)=>{
    thumb.addEventListener('click',()=>{
      if(main){
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src=thumb.dataset.imageUrl;
        main.alt=thumb.dataset.imageAlt||main.alt;
      }
      thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poedagar-855-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.p855').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const picker=root.querySelector('[data-p855-variant]');
  const main=root.querySelector('.p855__main');
  const thumbs=Array.from(root.querySelectorAll('.p855__thumb'));
  const price=root.querySelector('[data-p855-price]');
  const add=root.querySelector('[data-p855-add]');
  const label=root.querySelector('[data-p855-label]');
  if(!picker)return;
  const show=(url,alt,thumb)=>{
    if(main&&url){
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src=url;
      if(alt)main.alt=alt;
    }
    thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
  };
  const update=()=>{
    const option=picker.options[picker.selectedIndex];
    if(!option)return;
    if(price)price.textContent=option.dataset.price||'';
    const ok=option.dataset.available==='true';
    if(add)add.disabled=!ok;
    if(label)label.textContent=ok?'Add POEDAGAR 855':'Sold out';
    const thumb=thumbs.find(t=>t.dataset.mediaId===option.dataset.mediaId);
    if(thumb)show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb);
    else if(option.dataset.imageUrl)show(option.dataset.imageUrl,option.dataset.imageAlt,null);
    const url=new URL(window.location.href);
    url.searchParams.set('variant',option.value);
    window.history.replaceState({},'',url);
  };
  picker.addEventListener('change',update);
  thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{
    const linked=thumb.dataset.variantId;
    const option=linked?Array.from(picker.options).find(o=>o.value===linked):null;
    if(option){
      picker.value=linked;
      picker.dispatchEvent(new Event('change',{bubbles:true}));
    }else{
      show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb);
    }
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prismloop-watch-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.plw').forEach((root)=>{
  if(root.dataset.plwReady)return;
  root.dataset.plwReady='true';
  const picker=root.querySelector('[data-plw-variant]');
  const main=root.querySelector('.plw__main-image');
  const thumbs=Array.from(root.querySelectorAll('.plw__thumb'));
  const price=root.querySelector('[data-plw-price]');
  const mobilePrice=root.querySelector('[data-plw-mobile-price]');
  const add=root.querySelector('[data-plw-add]');
  const addLabel=root.querySelector('[data-plw-add-label]');
  if(!picker)return;
  const activate=(thumb)=>thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
  const show=(url,alt,thumb)=>{if(main&&url){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;if(alt)main.alt=alt}activate(thumb)};
  const update=()=>{
    const option=picker.options[picker.selectedIndex];
    if(!option)return;
    if(price)price.textContent=option.dataset.price||'';
    if(mobilePrice)mobilePrice.textContent=option.dataset.price||'';
    const available=option.dataset.available==='true';
    if(add)add.disabled=!available;
    if(addLabel)addLabel.textContent=available?'Add PrismLoop':'Sold out';
    const thumb=thumbs.find(t=>t.dataset.mediaId===option.dataset.mediaId);
    if(thumb)show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb);
    else if(option.dataset.imageUrl)show(option.dataset.imageUrl,option.dataset.imageAlt,null);
    const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
  };
  picker.addEventListener('change',update);
  thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{
    const linked=thumb.dataset.variantId;
    const option=linked?Array.from(picker.options).find(o=>o.value===linked):null;
    if(option){picker.value=linked;picker.dispatchEvent(new Event('change',{bubbles:true}))}
    else{show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb)}
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prizeclaw-keychain-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pc').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const picker=root.querySelector('[data-pc-variant]'),main=root.querySelector('.pc__main'),thumbs=[...root.querySelectorAll('.pc__thumb')],price=root.querySelector('[data-pc-price]'),add=root.querySelector('[data-pc-add]'),label=root.querySelector('[data-pc-label]');if(!picker)return;const show=(u,a,t)=>{if(main&&u){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=u;if(a)main.alt=a}thumbs.forEach(x=>x.classList.toggle('is-active',x===t))};const update=()=>{const o=picker.options[picker.selectedIndex];if(!o)return;if(price)price.textContent=o.dataset.price||'';const ok=o.dataset.available==='true';if(add)add.disabled=!ok;if(label)label.textContent=ok?'Grab one':'Sold out';const t=thumbs.find(x=>x.dataset.mediaId===o.dataset.mediaId);if(t)show(t.dataset.imageUrl,t.dataset.imageAlt,t);else if(o.dataset.imageUrl)show(o.dataset.imageUrl,o.dataset.imageAlt,null);const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u)};picker.addEventListener('change',update);thumbs.forEach(t=>t.addEventListener('click',()=>{const id=t.dataset.variantId,o=id?[...picker.options].find(x=>x.value===id):null;if(o){picker.value=id;picker.dispatchEvent(new Event('change',{bubbles:true}))}else show(t.dataset.imageUrl,t.dataset.imageAlt,t)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retro-watch-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-id]').forEach((section) => {
    if (section.dataset.rwReady) return;
    section.dataset.rwReady = 'true';
    const variantsNode = section.querySelector('[data-rw-variants]');
    const picker = section.querySelector('[data-rw-variant]');
    if (!variantsNode || !picker) return;
    const variants = JSON.parse(variantsNode.textContent);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    const mainImage = section.querySelector('.rw__main-image');
    const thumbnails = Array.from(section.querySelectorAll('[data-rw-image]'));
    const showImage = (url, alt) => {
      if (!mainImage || !url) return;
      mainImage.style.opacity = '0';
      mainImage.onload = () => { mainImage.style.opacity = '1'; };
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = url;
      if (alt) mainImage.alt = alt;
    };
    const activateThumbnail = (thumbnail) => {
      thumbnails.forEach((item) => item.classList.remove('is-active'));
      if (thumbnail) thumbnail.classList.add('is-active');
    };
    const update = () => {
      const variant = variants.find((item) => String(item.id) === picker.value);
      if (!variant) return;
      section.querySelector('[data-rw-price]').textContent = money.format(variant.price / 100);
      const mobilePrice = section.querySelector('[data-rw-mobile-price]');
      if (mobilePrice) mobilePrice.textContent = money.format(variant.price / 100);
      section.querySelectorAll('[data-rw-add], [data-rw-mobile-add]').forEach((button) => { button.disabled = !variant.available; });
      const label = section.querySelector('[data-rw-add-label]');
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const selectedOption = picker.options[picker.selectedIndex];
      const mediaId = selectedOption?.dataset.mediaId;
      const matchingThumbnail = thumbnails.find((item) => item.dataset.mediaId === mediaId);
      if (matchingThumbnail) {
        showImage(matchingThumbnail.dataset.rwImage, matchingThumbnail.dataset.rwAlt);
        activateThumbnail(matchingThumbnail);
      } else if (variant.featured_image) {
        showImage(variant.featured_image.src, variant.featured_image.alt || mainImage?.alt);
        activateThumbnail(null);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    picker.addEventListener('change', update);
    thumbnails.forEach((button) => button.addEventListener('click', () => {
      const linkedVariantId = button.dataset.rwVariantId;
      const linkedOption = linkedVariantId ? Array.from(picker.options).find((option) => option.value === linkedVariantId && !option.disabled) : null;
      if (linkedOption) {
        picker.value = linkedVariantId;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        showImage(button.dataset.rwImage, button.dataset.rwAlt);
        activateThumbnail(button);
      }
    }));
    const mobileAdd = section.querySelector('[data-rw-mobile-add]');
    if (mobileAdd) mobileAdd.addEventListener('click', () => section.querySelector('[data-rw-add]').click());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rose-gold-baddie-watch"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rgw-section]').forEach(function(section) {
    if (section.dataset.rgwReady) return;
    section.dataset.rgwReady = 'true';
    var mainImage = section.querySelector('.rgw__main-image');
    var thumbnails = Array.from(section.querySelectorAll('[data-rgw-image]'));
    var variantInput = section.querySelector('[data-buy-variant]');
    var variantsNode = section.querySelector('[data-rgw-variants]');
    var variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD' });

    function showImage(url, alt) {
      if (!mainImage || !url) return;
      mainImage.style.opacity = '0';
      mainImage.onload = function() { mainImage.style.opacity = '1'; };
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = url;
      if (alt) mainImage.alt = alt;
    }

    function activateThumbnail(button) {
      thumbnails.forEach(function(item) { item.classList.remove('is-active'); });
      if (button) button.classList.add('is-active');
    }

    function syncVariant() {
      if (!variantInput) return;
      var variant = variants.find(function(item) { return String(item.id) === String(variantInput.value); });
      if (!variant) return;
      var price = section.querySelector('[data-buy-price]');
      if (price) price.textContent = money.format(variant.price / 100);
      var button = section.querySelector('[data-buy-atc]');
      var label = section.querySelector('[data-buy-atc-label]');
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.featured_image && variant.featured_image.src) {
        showImage(variant.featured_image.src, variant.featured_image.alt || (mainImage ? mainImage.alt : ''));
        var linked = thumbnails.find(function(item) { return String(item.dataset.rgwVariantId || '') === String(variant.id); });
        activateThumbnail(linked || null);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    if (variantInput && variantInput.tagName === 'SELECT') variantInput.addEventListener('change', syncVariant);

    thumbnails.forEach(function(button) {
      button.addEventListener('click', function() {
        var linkedVariantId = button.dataset.rgwVariantId;
        if (linkedVariantId && variantInput && variantInput.tagName === 'SELECT') {
          var linkedOption = Array.from(variantInput.options).find(function(option) { return option.value === linkedVariantId && !option.disabled; });
          if (linkedOption) {
            variantInput.value = linkedVariantId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
        showImage(button.dataset.rgwImage, button.dataset.rgwAlt);
        activateThumbnail(button);
      });
    });

    var mobileCta = section.querySelector('[data-rgw-mobile-cta]');
    if (mobileCta) mobileCta.addEventListener('click', function() {
      var buy = section.querySelector('#rgw-buy-' + section.dataset.rgwSection);
      if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royal-cat-sofa"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rcs-section]').forEach((root) => {
    const mainImage = root.querySelector('.rcs__hero-image');
    const form = root.querySelector('[data-buy-form]');
    const mobileAdd = root.querySelector('[data-rcs-mobile-add]');

    root.querySelectorAll('[data-rcs-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.rcsImg;
        mainImage.alt = btn.dataset.rcsAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-rcs-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
    }));

    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stealthdial-d50-watch-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sd50').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const main=root.querySelector('.sd50__main');
  const thumbs=Array.from(root.querySelectorAll('.sd50__thumb'));
  thumbs.forEach((thumb)=>{
    thumb.addEventListener('click',()=>{
      if(main){
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src=thumb.dataset.imageUrl;
        main.alt=thumb.dataset.imageAlt||main.alt;
      }
      thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["switchside-sling-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sss').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const picker=root.querySelector('[data-sss-variant]');
  const main=root.querySelector('.sss__main');
  const thumbs=Array.from(root.querySelectorAll('.sss__thumb'));
  const price=root.querySelector('[data-sss-price]');
  const mobilePrice=root.querySelector('[data-sss-mobile-price]');
  const add=root.querySelector('[data-sss-add]');
  const label=root.querySelector('[data-sss-label]');
  if(!picker)return;
  const activate=(thumb)=>thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
  const show=(url,alt,thumb)=>{if(main&&url){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;if(alt)main.alt=alt}activate(thumb)};
  const update=()=>{
    const option=picker.options[picker.selectedIndex];
    if(!option)return;
    if(price)price.textContent=option.dataset.price||'';
    if(mobilePrice)mobilePrice.textContent=option.dataset.price||'';
    const available=option.dataset.available==='true';
    if(add)add.disabled=!available;
    if(label)label.textContent=available?'Add SwitchSide Sling':'Sold out';
    const thumb=thumbs.find(t=>t.dataset.mediaId===option.dataset.mediaId);
    if(thumb)show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb);
    else if(option.dataset.imageUrl)show(option.dataset.imageUrl,option.dataset.imageAlt,null);
    const url=new URL(window.location.href);
    url.searchParams.set('variant',option.value);
    window.history.replaceState({},'',url);
  };
  picker.addEventListener('change',update);
  thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{
    const linked=thumb.dataset.variantId;
    const option=linked?Array.from(picker.options).find(o=>o.value===linked):null;
    if(option){picker.value=linked;picker.dispatchEvent(new Event('change',{bubbles:true}))}
    else{show(thumb.dataset.imageUrl,thumb.dataset.imageAlt,thumb)}
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tritrack-x3-watch-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ttx3').forEach((root)=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const main=root.querySelector('.ttx3__main');
  const thumbs=Array.from(root.querySelectorAll('.ttx3__thumb'));
  thumbs.forEach((thumb)=>{
    thumb.addEventListener('click',()=>{
      if(main){
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src=thumb.dataset.imageUrl;
        main.alt=thumb.dataset.imageAlt||main.alt;
      }
      thumbs.forEach(t=>t.classList.toggle('is-active',t===thumb));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vector-2858-chronograph"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.v28').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const picker=root.querySelector('[data-v28-variant]'),main=root.querySelector('.v28__main'),thumbs=[...root.querySelectorAll('.v28__thumb')],price=root.querySelector('[data-v28-price]'),add=root.querySelector('[data-v28-add]'),label=root.querySelector('[data-v28-label]');if(!picker)return;const show=(url,alt,thumb)=>{if(main&&url){main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=url;if(alt)main.alt=alt}thumbs.forEach(t=>t.classList.remove('is-active'));if(thumb)thumb.classList.add('is-active')};picker.addEventListener('change',()=>{const o=picker.options[picker.selectedIndex];if(price)price.textContent=o.dataset.price||'';const ok=o.dataset.available==='true';if(add)add.disabled=!ok;if(label)label.textContent=ok?'Add Vector 2858':'Sold out';const t=thumbs.find(x=>x.dataset.media===o.dataset.media);if(t)show(t.dataset.url,t.dataset.alt,t);else if(o.dataset.url)show(o.dataset.url,o.dataset.alt,null)});thumbs.forEach(t=>t.addEventListener('click',()=>{if(t.dataset.variant&&[...picker.options].some(o=>o.value===t.dataset.variant)){picker.value=t.dataset.variant;picker.dispatchEvent(new Event('change',{bubbles:true}))}else show(t.dataset.url,t.dataset.alt,t)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vintage-diaper-tote"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vdt-section]').forEach((root) => {
    const mainImage = root.querySelector('.vdt__hero-image');
    const select = root.querySelector('[data-buy-variant]');
    const form = root.querySelector('[data-buy-form]');
    const price = root.querySelector('[data-buy-price]');
    const mobilePrice = root.querySelector('[data-vdt-mobile-price]');
    const atc = root.querySelector('[data-buy-atc]');
    const atcLabel = root.querySelector('[data-buy-atc-label]');
    const mobileAdd = root.querySelector('[data-vdt-mobile-add]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-vdt-variants]')?.textContent || '[]'); } catch(e) {}

    const money = (cents) => {
      const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(cents/100); }
      catch(e){ return '$' + (cents/100).toFixed(2); }
    };

    const updateVariant = (id) => {
      const variant = variants.find((v) => String(v.id) === String(id));
      if (!variant) return;
      if (select) select.value = String(variant.id);
      const formatted = money(variant.price);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      if (atc) atc.disabled = !variant.available;
      if (mobileAdd) mobileAdd.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      const mediaId = variant.featured_media ? String(variant.featured_media.id) : '';
      const matchingThumb = mediaId ? Array.from(root.querySelectorAll('[data-vdt-img]')).find((btn) => String(btn.dataset.mediaId) === mediaId) : null;
      if (matchingThumb && mainImage) {
        mainImage.src = matchingThumb.dataset.vdtImg;
        mainImage.alt = matchingThumb.dataset.vdtAlt || '';
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-vdt-img]').forEach((btn) => btn.classList.toggle('is-active', btn === matchingThumb));
      } else if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch(e) {}
    };

    root.querySelectorAll('[data-vdt-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.vdtImg;
        mainImage.alt = btn.dataset.vdtAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-vdt-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
      const linked = variants.find((variant) => variant.featured_media && String(variant.featured_media.id) === String(btn.dataset.mediaId));
      if (linked) updateVariant(linked.id);
    }));

    select?.addEventListener('change', () => updateVariant(select.value));
    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y2k-leopard-bag-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ylb-section]').forEach((root) => {
    const mainImage = root.querySelector('.ylb__hero-image');
    const select = root.querySelector('[data-buy-variant]');
    const form = root.querySelector('[data-buy-form]');
    const price = root.querySelector('[data-buy-price]');
    const mobilePrice = root.querySelector('[data-ylb-mobile-price]');
    const atc = root.querySelector('[data-buy-atc]');
    const atcLabel = root.querySelector('[data-buy-atc-label]');
    const mobileAdd = root.querySelector('[data-ylb-mobile-add]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-ylb-variants]')?.textContent || '[]'); } catch(e) {}

    const displayName = (title) => {
      const value = String(title || '');
      if (/bwhuasebag-red/i.test(value)) return 'Red Leopard';
      if (/bwhuasebag-ka/i.test(value)) return 'Khaki Leopard';
      if (/bwhuasebag-hei/i.test(value)) return 'Black Leopard';
      return value;
    };

    if (select) {
      Array.from(select.options).forEach((option) => {
        const soldOut = /—\s*Sold out/i.test(option.textContent || '');
        const variant = variants.find((item) => String(item.id) === String(option.value));
        if (variant) option.textContent = displayName(variant.title) + (soldOut ? ' — Sold out' : '');
      });
    }

    const money = (cents) => {
      const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(cents/100); }
      catch(e){ return '$' + (cents/100).toFixed(2); }
    };

    const updateVariant = (id) => {
      const variant = variants.find((v) => String(v.id) === String(id));
      if (!variant) return;
      if (select) select.value = String(variant.id);
      const formatted = money(variant.price);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      if (atc) atc.disabled = !variant.available;
      if (mobileAdd) mobileAdd.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      const mediaId = variant.featured_media ? String(variant.featured_media.id) : '';
      const matchingThumb = mediaId ? Array.from(root.querySelectorAll('[data-ylb-img]')).find((btn) => String(btn.dataset.mediaId) === mediaId) : null;
      if (matchingThumb && mainImage) {
        mainImage.src = matchingThumb.dataset.ylbImg;
        mainImage.alt = matchingThumb.dataset.ylbAlt || '';
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-ylb-img]').forEach((btn) => btn.classList.toggle('is-active', btn === matchingThumb));
      } else if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      } catch(e) {}
    };

    root.querySelectorAll('[data-ylb-img]').forEach((btn) => btn.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = btn.dataset.ylbImg;
        mainImage.alt = btn.dataset.ylbAlt || '';
        mainImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-ylb-img]').forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');
      const linked = variants.find((variant) => variant.featured_media && String(variant.featured_media.id) === String(btn.dataset.mediaId));
      if (linked) updateVariant(linked.id);
    }));

    select?.addEventListener('change', () => updateVariant(select.value));
    mobileAdd?.addEventListener('click', () => form?.requestSubmit());
  });
});

  } catch(e) { console.error(e); }
})();
})();
